module.exports = __webpack_public_path__ + "static/img/role.0f8189e.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/swbnzk/role.png
// module id = o6qw
// module chunks = 7